import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";
import {setParticipantListLoading} from "../participant/list";

const setLoading = (loading: boolean) => ({
  type: actionTypes.EXPERIENCE_BUILDER_LOADING,
  payload: loading
});

export const updateUserMetrics = (title: any, value: any) => ({
  type: actionTypes.UPDATE_USER_METRICS,
  payload: {
    title, value
  },
});

export const moveNextReelPage = (page: number) => ({
  type: actionTypes.CREATOR_EXPERIENCE_BUILDER_NEXT_PAGE,
  payload: page,
});

export const moveNextPage = (page: number) => ({
  type: actionTypes.CREATOR_EXPERIENCE_BUILDER_NEXT_PAGE,
  payload: page,
});

export const emptyUserMetrics = () => ({
  type: actionTypes.EMPTY_USER_METRICS,
  payload: '',
});

// creator onboarding get Success
const getUserAttributesSuccess = (items: any) => ({
  type: actionTypes.USER_ATTRIBUTE_GET_SUCCESS,
  payload: items,
});

// user Attribute update Success
const updateUserAttributesSuccess = (value: any) => ({
  type: actionTypes.USER_ATTRIBUTE_UPDATE_SUCCESS,
  payload: {
    value
  },
});

export const updateAsyncThumbnailImg = (img: any) => ({
  type: actionTypes.CHANGE_ASYNC_THUMBNAIL_IMG,
  payload: img,
});

// get braintrust list success
export const getBraintrustListSuccess = (res: any) => ({
  type: actionTypes.BRAINTRUST_LIST,
  payload: res
});

//get User Attributes
export const getUserAttributes = (client: any, req: any) => {
  return (dispatch: any) => {
      client.query({
      query: ImmersionGQL.queryGetUserAttributes,
      fetchPolicy: "no-cache",
      variables: { user_id: req.user_id }
    })
      .then((response: any) => {
        if (response.data.getUserAttributes) {
          dispatch(getUserAttributesSuccess(response.data.getUserAttributes));
        }
      })
      .catch(() => {})
  }
};

//update User Attributes
export const updateUserAttributes = (client: any, req: any) => {
  return (dispatch: any) => {
    // dispatch(updateUserAttributesSuccess(req.temporary_value));
    const variables = {
      temporary_value: req.temporary_value,
      metrics_value:"CREATOR_EXPERIENCE_BUILDER",
      user_id: req.user_id,
      // metrics_type: "CREATOR_EXPERIENCE_BUILDER"
    }
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateUserAttributes,
      fetchPolicy: "no-cache",
      variables
    })
      .then(() => {
        dispatch(updateUserAttributesSuccess(req.temporary_value));
      }).catch(() => {

      })
  }
}

// experience dategories success
const experienceCategoriesSuccess = (value: any) => ({
  type: actionTypes.EXPERIENCE_CATEGORIES_SUCCESS,
  payload: value,
});

// experience categories
export const experienceCategories = (client: any) => {
  return (dispatch: any) => {
      client.query({
      query: ImmersionGQL.queryExperienceCategories,
      fetchPolicy: "no-cache",
    })
    .then((response: any) => {
      if (response.data.experienceCategories) {
        dispatch(experienceCategoriesSuccess(response.data.experienceCategories));
      }
    })
    .catch(() => {})
  }
};

//validate session code
export const validateSessionCode = async (client: any, session_code: string) => {
  const req = {
    session_code: session_code
  };
  const variables = { ...req };
  return await client.query({
    query: ImmersionGQL.queryValidateSessionCode,
    fetchPolicy: "no-cache",
    variables
  });
};

// get braintrust list
export const getBraintrustList = (experience: any) => {
  return (dispatch: any) => {
    const variables = {
    }
    experience.query({
      query: ImmersionGQL.mutationGetBraintrustList,
      fetchPolicy: "no-cache",
      variables
    })
      .then((res: any) => {
        if (res?.data?.getBraintrustList?.status === "true" && res?.data?.getBraintrustList?.data) {
          dispatch(getBraintrustListSuccess(res?.data?.getBraintrustList?.data))
        } else {
          dispatch(getBraintrustListSuccess([]))
        }
      }).catch(() => {
        dispatch(getBraintrustListSuccess([]))
      })
  }
};

export const mutationUpdateUserMetricValue = (client: any, req: any) => {
  return () => {
    const variables = {...req};
    client.query({
      query: ImmersionGQL.mutationUpdateUserMetricValue,
      fetchPolicy: "no-cache",
      variables
    })
  }
};

const getUserMetricValueSuccess = (value: any) => ({
  type: actionTypes.GET_USERMETRICVALUE_SUCCESS,
  payload: value,
});

export const getUserMetricValue = (client: any, req: any) => {
  return (dispatch: any) => {
    const variables = { ...req };
    client.query({
      query: ImmersionGQL.getUserMetricValue,
      fetchPolicy: "no-cache",
      variables
    })
      .then((res: any) => {
        if (res.data.getUserMertixValue) {
          dispatch(getUserMetricValueSuccess(res.data.getUserMertixValue));
        }
      })
      .catch(() => {})
  }
};

export const sendNeedHelpEmail = (client: any, objectData: any, cb: any) => {
  return () => {
    client.query({
      query: ImmersionGQL.querySendEmailTemplate,
      fetchPolicy: "no-cache",
      variables: {
        template_type: "experience_measure_help",
        objectData: objectData
      }
    })
      .then((response: any) => {
        if (response.data.sendEmailTemplate) {
          cb(response.data.sendEmailTemplate)
        }
      })
      .catch(() => {
        cb(false);
      })
  }
};

export const getSelectedListsParticipants = (client: any, request: any) => {
  return (dispatch: any) => {
    dispatch(setParticipantListLoading(true));
    client.query({
      query: ImmersionGQL.getSelectedListsParticipants,
      fetchPolicy: "no-cache",
      variables: request
    }).then((res: any) => {
      dispatch(updateUserMetrics('listsParticipants', res.data.getAllParticipantsList));
      dispatch(setParticipantListLoading(false));
      dispatch(updateUserMetrics('addParticipantList', false));
    }).catch(() => {
      dispatch(updateUserMetrics('listsParticipants', []));
      dispatch(setParticipantListLoading(false));
      dispatch(updateUserMetrics('addParticipantList', false));
    })
  }
};

const getHubsSuccess = (hubs: any[]) => ({
  type: actionTypes.GET_HUBS_SUCCESS,
  payload: hubs
});

export const getHubs = (client: any, request: any, callback?: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    client.query({
      query: ImmersionGQL.getHubsQuery,
      fetchPolicy: "no-cache",
      variables: request
    }).then((res: any) => {
      dispatch(getHubsSuccess(res.data.listHubDevices));
      dispatch(setLoading(false));
      callback && callback(true);
    }).catch(() => {
      dispatch(getHubsSuccess([]));
      dispatch(setLoading(false));
      callback && callback(true);
    })
  }
};